import { Reveal, Eyebrow } from "./Reveal";
import { PROGRAM_21 } from "../../data";

export const Program21 = () => {
  return (
    <section id="programme-21j" className="relative bg-sand-light py-24 sm:py-32" data-testid="program-21-section">
      <div className="max-w-6xl mx-auto px-6 sm:px-8">
        <div className="max-w-3xl">
          <Reveal><Eyebrow>L'innovation CSE exclusive</Eyebrow></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-4 font-serif font-semibold tracking-tight text-ocean text-3xl sm:text-4xl lg:text-5xl leading-[1.08]">
              La méthode 21 jours : l'effet<br className="hidden sm:block" /> bien-être qui continue au bureau
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-5 text-base sm:text-lg text-muted2">
              21 jours pour ancrer une habitude positive, renforcer les synergies d'équipe et maximiser le ROI de votre événement CSE.
            </p>
          </Reveal>
        </div>

        <div className="mt-16 relative">
          <div className="hidden md:block absolute top-8 left-0 right-0 h-px bg-gradient-to-r from-gold/10 via-gold/40 to-gold/10" />
          <div className="grid md:grid-cols-3 gap-8">
            {PROGRAM_21.map((s, i) => (
              <Reveal key={i} delay={i * 0.12}>
                <div className="relative" data-testid={`program-step-${i}`}>
                  <div className="w-16 h-16 rounded-full bg-ocean text-gold font-serif text-lg font-semibold flex items-center justify-center border-4 border-sand-light shadow-lg">
                    {String(i + 1).padStart(2, "0")}
                  </div>
                  <span className="mt-5 inline-block text-xs uppercase tracking-[0.18em] font-semibold text-coral">{s.day}</span>
                  <h3 className="mt-2 font-serif text-2xl font-semibold text-ocean leading-tight">{s.title}</h3>
                  <p className="mt-3 text-sm text-muted2 leading-relaxed">{s.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
